module.exports = __webpack_public_path__ + "img/reset-password-dark.f829a55c.svg";